import styled from "@emotion/styled";
import { css } from "@emotion/core";
import { NectarTheme } from "@nectarTypes";
import { Button, Text } from "nectar-ui";

export const LawsuitItemContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    display: grid;
    grid-template-areas:
      "body"
      "button"
      "divider";

    grid-template-rows: 1fr;
    grid-template-columns: 1fr;

    ${theme.breakpoints.sm} {
      grid-template-areas:
        "body button"
        "divider divider";

      grid-template-rows: 1fr auto;
      grid-template-columns: 1fr 190px;
    }
  `}
`;

export const LawsuitItemTitleContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    display: flex;
    column-gap: ${theme.spacings.sm};
    flex-wrap: wrap;
    width: 90%;
  `}
`;

export const LawsuitItemHeaderContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    display: flex;
    justify-content: flex-start;
    column-gap: ${theme.spacings.sm};
    align-items: center;

    & svg {
      color: ${theme.colors.gray500};
    }

    > .text-container {
      display: -webkit-box;
      flex-direction: row;
      column-gap: 8px;
      flex-wrap: wrap;
      width: 90%;
      > p {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        line-clamp: 3;
        -webkit-box-orient: vertical;
      }
    }
  `}
`;

export const LawsuitItemBody = styled.div<NectarTheme>`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    row-gap: ${theme.spacings.xs};
    grid-area: body;
    > p {
      margin-left: 28px;
    }
  `}
`;

export const ButtonContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    grid-area: button;

    ${theme.breakpoints.xs} {
      margin-top: ${theme.spacings.lg};
    }
    ${theme.breakpoints.sm} {
      margin-top: 0;
    }
  `}
`;

export const StatusBadge = styled.span<NectarTheme & { active: boolean }>`
  ${({ theme, active }) => css`
    border-radius: ${theme.spacings.xxs};
    color: ${active ? theme.colors.primary500 : theme.colors.gray500};
    background-color: ${active ? theme.colors.primary100 : theme.colors.gray100};
    padding: 2px 8px;
    width: fit-content;
    height: fit-content;
    line-height: 1.4;
  `}
`;

export const BadgeContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    display: flex;
    column-gap: ${theme.spacings.xs};
  `}
`;

export const ViewButton = styled(Button)<NectarTheme>`
  ${({ _theme }) => css`
    transition: none;
    line-height: 1.4;
  `}
`;

export const TitleText = styled(Text)<NectarTheme>`
  ${({ _theme }) => css`
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;
  `}
`;
